Lyte.Component.register("lyte-tree-table-child", {
	data : function(){
		return {
			ltPropData : Lyte.attr('array' , {
				default : []
			}),
			hideTemplate : Lyte.attr('boolean', {
				default : true
			}),
			indexVar: Lyte.attr('string', {
				default: ''
			})
		}		
	},
	actions : {
		// Functions for event handling
	},
	methods : {
		// Functions which can be used as callback in the component.
	}
});



Lyte.Component.registerHelper('lyteTableTreeLevel' , function(parentIndex , index){
	return ((parentIndex +" "+ index).trim()).split(' ').length
})

Lyte.Component.registerHelper('lyteTableTreeIndexHelp' , function(parentIndex , index){
	return ((parentIndex +" "+ index).trim())
})